import axiosConfig from "./axiosConfig";

// One recorded lead search. Running a search records it - there is no save
// action - and the NAME is its identity, so re-running under the same name
// replaces that search's stored result set. See
// building-manager-api/docs/Y2026-Q3/design-lead-search-history.md.
export interface LeadSearchSummary {
  id: string;
  name: string;
  criteria: {
    postcodeOutward?: string | null;
    minFloorAreaSqm?: number | null;
    maxFloorAreaSqm?: number | null;
    radiusKm?: number | null;
    outcodes?: string[];
  };
  // Rows in the frozen set. Can be below `totalMatched` when the run was capped.
  resultCount: number;
  // How many of this search's own rows are leads now, whoever promoted them.
  // Counted off the row set, not the tag: a building found by two searches
  // keeps only the first one's tag, so a tag count read 0 for the second while
  // its rows still rendered as Lead. `/leads?savedSearch=<id>` narrows to
  // exactly this set, so the link shows the number the operator clicked.
  promotedCount: number;
  totalMatched: number;
  truncated: boolean;
  createdBy: string | null;
  createdAt: string;
  lastRunAt: string;
}

export interface LeadSearchesResponse {
  searches: LeadSearchSummary[];
}

const getLeadSearches = async (
  authToken: string
): Promise<LeadSearchesResponse> => {
  const { data } = await axiosConfig.get("/leads/searches", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadSearches;
